class ValidatePhoneNumber extends ValidatePage {
    constructor(_parent) {
        // this.debug = true; // uncomment for debug obj
        super();
        this.parent = _parent;
        this.regex = {
            extension: /^\d{1,10}$/,

        };
        this.number = { elm: '', id: '', classlist: '',  value: '' };
        this.extension = { elm: '', id: '', classlist: '',  value: '' };
        this.type ={ elm: '', id: '', classlist: '', value: '' };
        this.is_valid = false;

        this.debug = this.parent.debug.extends.ValidatePhoneNumber; // Turn on debugger in ValidatePage
    }  

    async _validate($this){
        this.define_elems($this);
        this.is_valid = await this.process_validations();

        if(this.debug)
            console.log(this, "ValidatePhoneNumber - debug");

        return this.is_valid;
    }

    define_elems($this){
        if($this.hasClass('js-phone-number')){
            this.number = this.parent.define_elem($this);
            this.extension = this.get_phone_extension($this);
            this.type = this.get_phone_type($this);
            this.country_code = this.get_phone_number_country_code($this);
        }
        else if($this.hasClass('js-phone-extension')){
            this.extension = this.parent.define_elem($this);
            this.number = this.get_phone_number($this);
            this.type = this.get_phone_type($this);
            this.country_code = this.get_phone_number_country_code($this);
        }
        else if($this.hasClass('js-phone-type')){
            this.type = this.parent.define_elem($this);
            this.number = this.get_phone_number($this);
            this.extension = this.get_phone_extension($this);
            this.country_code = this.get_phone_number_country_code($this);
        }
    }

    async process_validations(){
        const select_allowed_values = ['office', 'mobile', 'fax', 'home', 'other'];
        if(
            this.number.value != '' || this.extension.value != '' || this.type.value != '' 
            ||
            this.number.classlist.includes('js-required') && this.number.value == '' && this.extension.value == '' && this.type.value == '' 
        ){
            var isNumberValid = false;
            try {
                var parsedNumber = new libphonenumber.parsePhoneNumber(
                  this.number.value, this.country_code.value.toUpperCase()
                )
                isNumberValid = parsedNumber.isValid();
            } catch (error) {
                // Just ignore if it throws error as we know that there has been an error already and we can simply
                // assume that the input number is not valid.
                // console.log(error)
            }
            if (!isNumberValid) {
                this.parent.failed_obj_push( { target: this.number.id, msg: get_language_translation('LANG_LABEL_PHONE_NUMBER_INVALID') } );
                if( this.extension.value != '' && !this.regex.extension.test(this.extension.value) )
                    this.parent.failed_obj_push( { target: this.extension.id, msg: get_language_translation('LANG_LABEL_INVALID_EXTENSION') } );
                if(!select_allowed_values.includes(this.type.value))
                    this.parent.failed_obj_push( { target: this.type.id, msg: get_language_translation('LANG_TYPE_IS_REQUIRED') } );
            
                return false;
            }

            if( !select_allowed_values.includes(this.type.value) ){
                this.parent.failed_obj_push( { target: this.type.id, msg: get_language_translation('LANG_LABEL_PHONE_NUMBER_TYPE_INVALID') } );
                if(!isNumberValid)
                    this.parent.failed_obj_push( { target: this.number.id, msg: get_language_translation('LANG_LABEL_PHONE_NUMBER_INVALID') } );

                return false;
            }

            if(this.extension.value != ''){
                if( !this.regex.extension.test(this.extension.value) ){
                    this.parent.failed_obj_push( { target: this.extension.id, msg: get_language_translation('LANG_LABEL_INVALID_EXTENSION') } );
                    return false;
                }

                if(!isNumberValid){
                    this.parent.failed_obj_push( { target: this.number.id, msg: get_language_translation('LANG_LABEL_PHONE_NUMBER_INVALID') } );
                    return false;
                }
                if( !select_allowed_values.includes(this.type.value) ){
                    this.parent.failed_obj_push( { target: this.type.id, msg: get_language_translation('LANG_LABEL_PHONE_NUMBER_INVALID') } );
                    return false;
                }
            }

            return true;
        }

        return true;
    }

    get_phone_container($el){
        const $phoneContiner = $el.parent().closest('.am-section-section');
        return $phoneContiner;
    }
        
    get_phone_type($el){
        const $phoneContiner = this.get_phone_container($el);
        const $phoneType = $phoneContiner.find('select.js-phone-type');
        var type =  this.parent.define_elem($phoneType);
    
       return type
    }

    get_phone_extension($el){
        const $phoneContiner = this.get_phone_container($el);
        const $phoneExtension = $phoneContiner.find('.js-phone-extension');
        var extension =  this.parent.define_elem($phoneExtension);
    
       return extension
    }
    
    get_phone_number($el){
        const $phoneContiner = this.get_phone_container($el);
        const $phoneNumber = $phoneContiner.find('.js-phone-number');
        var number =  this.parent.define_elem($phoneNumber);
    
       return number;
    }

    get_phone_number_country_code($el){
        const $phoneContiner = this.get_phone_container($el);
        const $phoneNumber = $phoneContiner.find('.base_country_class');
        return this.parent.define_elem($phoneNumber);
    }
} 